/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Theme Customizer Only
if (Shopify.designMode) {
  //reload Image Carousel section flickity elements in theme customizer during changes
  document.addEventListener("shopify:section:load", function(event){
    var imgCarousels = document.querySelectorAll('.image-carousel__parent');
    for (var i = 0; i < imgCarousels.length; i++) {
      new Flickity( '#'+imgCarousels[i].id, {
        "contain": true,
        "groupCells": true,
        "prevNextButtons": true,
        "pageDots": true,
        "wrapAround": false,
        "freeScroll": false,
        "cellAlign": "center",
        "dragThreshold": 8
      });
    }
  });
}

function bindFooterNav() {
  const navHeadings = document.querySelectorAll('.Footer__Title');
  for (let i = 0; i < navHeadings.length; i++) {
    navHeadings[i].addEventListener('click', (e) => {
      const parent = e.target.closest('.Footer__Block');
      const sibling = e.target.nextElementSibling;
      const link = parent.querySelector('.Linklist__Item');
      let linkHeight = link.offsetHeight;
      linkHeight += parseInt(window.getComputedStyle(link).getPropertyValue('margin-top'));
      linkHeight += parseInt(window.getComputedStyle(link).getPropertyValue('margin-bottom'));
      linkHeight += parseInt(window.getComputedStyle(link).getPropertyValue('padding-top'));
      linkHeight += parseInt(window.getComputedStyle(link).getPropertyValue('padding-bottom'));
      const quantity = parent.getElementsByClassName('Linklist__Item').length;
      const listHeight = linkHeight * quantity;

      // Cerrar todos los bloques abiertos excepto el actual
      const allBlocks = document.querySelectorAll('.Footer__Block.Footer__Block--open');
      allBlocks.forEach(block => {
        if (block !== parent) {
          block.classList.remove('Footer__Block--open');
          const blockSibling = block.querySelector('.Footer__Title').nextElementSibling;
          if (blockSibling) blockSibling.style.height = '0px';
        }
      });

      if (parent.classList.contains('Footer__Block--open')) {
        parent.classList.remove('Footer__Block--open');
        sibling.style.height = 0 + 'px';
      } else {
        parent.classList.add('Footer__Block--open');
        sibling.style.height = listHeight + 'px';
      }
    });
  }
}

function bindSoldOutView() {
    const isPDP = !!document.querySelector('.template-product');
    if (!isPDP) return;

    const variantItems = document.querySelectorAll('.ProductForm__Variants .HorizontalList__Item');
    for (let i = 0; i < variantItems.length; i++) {
        variantItems[i].addEventListener('click', (event) => {
            if (event.target.tagName != 'LABEL' ) return;

            setTimeout(function () {
                const addToCartBtn = document.querySelector('.Product__Info .ProductForm__AddToCart');
                const productForm = document.querySelector('.ProductForm__Variants');

                if (addToCartBtn.hasAttribute('data-action')) productForm.classList.remove('ProductForm__Variants--soldOut');
                else productForm.classList.add('ProductForm__Variants--soldOut');
            }, 0);            
        });
    }
}

function communityPage() {
    const showMoreBtn = document.querySelector('.js-com-showmore');
    const isCOM = !!showMoreBtn;
    if (!isCOM) return;

    const startTextContent = showMoreBtn.textContent;
    showMoreBtn.addEventListener('click', function() {
        const parent = this.closest('div');
        if (parent.classList.contains('is-open')) {
            this.textContent = startTextContent;
            parent.classList.remove('is-open');
        } else {
            this.textContent = 'show less';
            parent.classList.add('is-open');
        }

        // Safari height fix
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            const el = parent.querySelector('.CommunityPage__Members-content');
            el.style.display = 'none';
            setTimeout(function () {
                el.style.display = 'block';
            }, 0); 
        }
               
    });
}

function instagramBlock() {
    if (!!document.querySelector('#shopify-section-instagram') == false) return;

    // Check if posts loaded
    let checkPostsTimer = setInterval(function() {
        const posts = document.querySelectorAll('.shg-ig-posts').length
        if (posts != 0) {
            clearInterval(checkPostsTimer);
            const flkty = new Flickity( '.shg-ig-posts-container', {
                freeScroll: true,
                contain: true,
                prevNextButtons: false,
                pageDots: false
            });
        }
    }, 100);
}
function seoplpShowmore() {
    const $seoContainer = document.querySelector('.js-seo-content');
    if (!$seoContainer) {
      return;
    }
    const $seoFirstP = $seoContainer.querySelector('p:first-child'); 
    const $seoBtn = document.querySelector('.js-seo-action');
    
    const seoFirstP_Height = $seoFirstP.offsetHeight || 80;
    const fullHeight = $seoContainer.offsetHeight
    $seoContainer.style.height = seoFirstP_Height+"px";
    $seoBtn.addEventListener('click', function() {
        $seoBtn.classList.toggle('seo-section__action--open')
        
        if ($seoBtn.classList.contains('seo-section__action--open')){
          $seoContainer.style.height = fullHeight+"px";
          $seoBtn.querySelector('.js-seo-action__text').textContent = 'LESS'
        }else {
          $seoContainer.style.height = seoFirstP_Height+"px";
          $seoBtn.querySelector('.js-seo-action__text').textContent = 'MORE'
        }
    });
}

function searchOutside() {
  const search = document.getElementById('Search');
  const searchButton = document.getElementById('Item--search');
  const searchButtonMobile = document.querySelector('.Header__Icon--search');

    document.addEventListener('click', function (e) {
        let searchAttr = search.getAttribute('aria-hidden');

        if (searchAttr !== 'true') {
            if (e.target.closest('#Search') != search && e.target != searchButton && e.target != searchButtonMobile) {
                searchButton.click();
            }
        }
    });

}

function headerScroll(){
    window.addEventListener("scroll", function (){
        if(window.scrollY > 50 && document.body.clientWidth > 1440) {
            document.body.classList.add('header-scroll');
        } else {
            document.body.classList.remove('header-scroll');
        }
    });
}

const backMobileBtn = document.querySelector('.Collapsible__Button2');
function backToMobileMenu(){
    backMobileBtn.addEventListener("click", function (){
        var sidebarMenu = document.getElementById('sidebar-menu');
        sidebarMenu.classList.remove('child-menu-open');

    document.querySelectorAll('.Collapsible__Button').forEach(function(item){
            item.setAttribute('aria-expanded', 'false');
        });

    document.querySelectorAll('.Collapsible__Inner').forEach(function(item){
            item.style.overflow = 'hidden';
        });
    });
}



backToMobileMenu();
headerScroll();
searchOutside();
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function(e) {
    var target = e.target.closest('.Cart__Checkout');
    if (target) {
        target.dataset.disabled = 'true';
      setTimeout(function () {
          target.datased.disabled = 'false';
      });
      }
  });
});

bindFooterNav();
// bindSoldOutView();
communityPage();
instagramBlock();
seoplpShowmore();

const $giftMsg = document.querySelector('.js-gift-msg');

if ($giftMsg) {
  window.addEventListener('load', function () {
    $giftMsg.addEventListener('click', giftMsgHandler)
  });
}

function giftMsgHandler(event) {
  const target = event.target;
  const $textareaMsg = $giftMsg.querySelector('#cart-note');
  const $resultContainer = $giftMsg.querySelector('[data-gift-msg="result"]')
  const $msgContainer = $giftMsg.querySelector('[data-gift-msg="msg-container"]')
  if (target.hasAttribute('data-gift-msg')) {
    if (target.dataset.giftMsg === 'remove') {
        $textareaMsg.value = '';
        $textareaMsg.textContent = '';
        
        request(window.routes.cartUrl + '/update.js', 'POST', {note: ''}).then(res => {
          if (!res.note) {
            $resultContainer.classList.add('cart-gift-msg--hidden');
            $msgContainer.classList.remove('gift-msg--hidden');
          }
        });
    }else if (target.dataset.giftMsg === 'save' &&  $textareaMsg.value.length ) {
      const $resultBody = $resultContainer.querySelector('[data-gift-msg="result-body"]');
      request(window.routes.cartUrl + '/update.js', 'POST', { note: $textareaMsg.value })
        .then(res => {
          $resultBody.textContent = ''
          if (res.note) {
            $msgContainer.classList.add('gift-msg--hidden');
            $resultBody.textContent = $textareaMsg.value;
            $resultContainer.classList.remove('cart-gift-msg--hidden');
          }
        });
    }
  }
}
// helpers function 
async function request(url, method = 'GET', data = null) {
  try {
    const headers = {};
    let body;

    if (data) {
      headers['Content-type'] = 'application/json; charset=UTF-8';
      headers['X-Requested-With'] = 'XMLHttpRequest'; // This is needed as currently there is a bug in Shopify that assumes this header
      body = JSON.stringify(data)
    }

    const response = await fetch(url, {
      method,
      headers,
      body
    });

    return await response.json();
  } catch (e) {
    console.warn('k0-Error: ', e.message)
  }
}

function selectVariantImg(mediaId, initialLoad) {
  var vids = document.querySelectorAll('.Product__SlideItem--video video');
  vids.forEach(function(vid) { 
    vid.pause();
  });
  //console.log('initialLoad', initialLoad);
  $('.Product__Slideshow.Product__Grid .Product__SlideItem--image, .Product__Slideshow.Product__Grid .Product__SlideItem--video').hide();

  $('.Product__Slideshow.Product__Grid').removeClass(function (index, className) {
    return (className.match(/\Product__Slideshow-items-\S+/g) || []).join(' ');
  });
  
  var slidesToShow = $('.Product__Slideshow.Product__Grid .Product__SlideItem--image[data-base-media-id="' + mediaId + '"], .Product__Slideshow.Product__Grid .Product__SlideItem--video[data-base-media-id="' + mediaId + '"]');
  $('.Product__Slideshow.Product__Grid').addClass('Product__Slideshow-items-' + slidesToShow.length);
  slidesToShow.show();
  
  var vidsToShow = document.querySelectorAll('.Product__Slideshow.Product__Grid .Product__SlideItem--video[data-base-media-id="' + mediaId + '"] video');
  vidsToShow.forEach(function(vid) { 
    vid.play();
  });
  
  if (initialLoad) {
    var initialSlides = $('.Product__Slideshow.Product__Grid .Product__SlideItem--image[data-base-media-id="0"], .Product__Slideshow.Product__Grid .Product__SlideItem--video[data-base-media-id="0"]');
    $('.Product__Slideshow.Product__Grid').addClass('Product__Slideshow-items-' + (initialSlides.length + slidesToShow.length));
    initialSlides.show();
    var initialVidsToShow = document.querySelectorAll('.Product__Slideshow.Product__Grid .Product__SlideItem--video[data-base-media-id="0"] video');
    initialVidsToShow.forEach(function(vid) { 
      vid.play();
    });
  }
}

// TP#1 - Stack "Makeup" under "Wellness" in desktop nav
jQuery(function($) {
  var $shopDD = $('.Heading[href*="collections/shop-all"] + .MegaMenu').addClass('tp-four-col');
  var $lastShopSub = $('.MegaMenu__Item', $shopDD).last();
  var $secondLastShopSub = $lastShopSub.prev();
  $lastShopSub.appendTo($secondLastShopSub);
  
  
  var $shopDD = $('.Heading[href*="collections/shop-all"] + .MegaMenu').addClass('tp-four-col');
  var $lastShopSub = $('.MegaMenu__Inner > .MegaMenu__Item', $shopDD).last();
  var $secondLastShopSub = $lastShopSub.prev();
  $lastShopSub.appendTo($secondLastShopSub);
  
  
  
  
  if ($('.Product__Gallery--has-variants').length) {
    console.log('TEST');
  	var mediaId = $('.Product__Gallery--has-variants').data('featured-media');
    selectVariantImg(mediaId, false);
  }
  
  if ($('.ProductItem__ColorSwatchList').length) {
    
    $('.ProductItem__ColorSwatchList').each(function() {
      var carousel = $(this).flickity({
        "contain": false,
        "groupCells": true,
        "prevNextButtons": true,
        "pageDots": false,
        "wrapAround": false,
        "freeScroll": true,
        "cellAlign": "center",
        "dragThreshold": 8,
        "initialIndex": "is-initial-select"
      });

      carousel.flickity( 'selectCell', carousel.find('.is-initial-select').index(), false, true );
    });
    
    
  }
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  $('.ProductForm__AddToCart').show();
  $('#BIS_trigger').hide();
  $('.ProductMeta__VariantDescription').removeClass("ProductMeta__VariantDescription--active");
  $('.ProductMeta__VariantDescription--' + variant.id).addClass("ProductMeta__VariantDescription--active");
  selectVariantImg(variant.featured_media.id, false);
});

// 
jQuery(document).ready(function($) {
  $('.product-tile .ColorSwatch__Radio, .boost-pfs-filter-product-item .ColorSwatch__Radio').on('change', function() {
    var target = this;
    var productItem = target.closest('.ProductItem, .boost-pfs-filter-product-item'),
            variantUrl = target.getAttribute('data-variant-url'),
        	variantId = target.getAttribute('data-variant-id');
    
        productItem.querySelector('.ProductItem__ImageWrapper, .boost-pfs-filter-product-item-image-link').setAttribute('href', variantUrl);
        productItem.querySelector('.ProductItem__Title > a, .boost-pfs-filter-product-item-title').setAttribute('href', variantUrl);
        var addButton = productItem.querySelector('.ProductItem__AddButton');
        if (addButton) {
          productItem.querySelector('.ProductItem__AddButton').setAttribute('data-variant', variantId);
          productItem.querySelector('.ProductItem__AddButton').setAttribute('href', '/cart/add?id=' + variantId + '&quantity=1');
        }

        // If we have a custom image for the variant, we change it
        var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate), .boost-pfs-filter-product-item-main-image');

        if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
          var newImageElement = document.createElement('img');
          if ($(originalImageElement).hasClass('boost-pfs-filter-product-item-main-image')) {
            newImageElement.className = 'boost-pfs-filter-product-item-main-image Image--fadeIn Image--lazyLoad';
          } else {
            newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
          }
          newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
          newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
          newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
          newImageElement.setAttribute('data-sizes', 'auto');

          if (!$(originalImageElement).hasClass('boost-pfs-filter-product-item-main-image')) {
            // Replace the original node
            if (window.theme.productImageSize === 'natural') {
              originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
            }

            originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
          }
          originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        }
    
  });
  
  $('.ProductItem__AddButton').on('click', function(e) {
    e.preventDefault();
    var button = $(this);
    var variantId = button.attr('data-variant');
    button.prop('disabled', true);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
    var params = {
      url: '/cart/add.js',
      data: "id=" + variantId + "&quantity=1",
      dataType: 'json'
    };
    $.post(params)
      .done(
        function(item) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          button.prop('disabled', false);
          
          document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variantId,
                quantity: 1
              }
          }));
        }
      )
      .fail(
        function(response) {
          button.prop('disabled', false);
          console.log('handle error');
        }
      );
    
  });
});


// T&P - Pinkify "Gift Guide" in menu
jQuery(function() {
  $('.SidebarMenu__Nav > .Collapsible > .Collapsible__Button:contains("Sale")').addClass('tp-pink');
  $('.Header__MainNav > ul > li > [href*="summer"]').parent().addClass('tp-pink');
});





// T&P - sms-signup-only tag
// jQuery(function() {
//   $('.js--sms-signup').click(function(e) {
//     e.preventDefault();
//     $('body').addClass('sms-signup-open');
//     $('.tp-attentive-form input[type="email"]').focus();
//   });

//   $('.js--sms-signup-close').click(function(e) {
//     $('body').removeClass('sms-signup-open');
//   });

//   $('form.tp-attentive-form').submit(function(e) {
//     e.preventDefault();

//     jQuery.ajax({
//       type: 'POST',
//       url: 'https://www.taylorpond.com/api/13l-sms.php',
//       data: {
//         email: $('.tp-attentive-form input[type="email"]').val(),
//         phone: $('.tp-attentive-form input[type="tel"]').val(),
//         cachebust: Date.now()
//       },
//       dataType: 'json',
//       error: function(xhr, status, error) {
//         console.log('ERROR', status, error);
//       },
//       complete: function() {
//         $('form.tp-attentive-form').hide();
//         $('.tp-attentive-form-success').show();
//       }
//     });
    
//   });
// });



// T&P - update mega menus
jQuery(function() {
  // Only apply to original header, not HeaderRevamped
  $('.MegaMenu__Inner .MegaMenu__Item .Linklist').not('.HeaderRevamped .MegaMenu__Inner .MegaMenu__Item .Linklist').each(function() {
      $(this).parent().addClass('has-linklist');
  });
  $('.MegaMenu__Inner .MegaMenu__Item:not(.has-linklist)').not('.HeaderRevamped .MegaMenu__Inner .MegaMenu__Item').addClass('no-linklist');


  $('.MegaMenu__Inner .MegaMenu__Item.no-linklist').not('.HeaderRevamped .MegaMenu__Inner .MegaMenu__Item').each(function() {
    var $prevCol = $(this).prev('.MegaMenu__Item');

    if ($prevCol.is('.no-linklist')) {
      $(this).appendTo($prevCol).addClass('tp-moved-col');
    }
  });

  // double-column 3rd level items with more than 11 links
  $('.MegaMenu__Item .Linklist').each(function() {
    if ($(this).children().length > 11) {
      $(this).parent().addClass('tp-double-col');
    }
  });


  //debug
  // setInterval(function() {
  //   $('.HorizontalList__Item .MegaMenu').last().attr('aria-hidden', false);
  // }, 100);

});

// T&P - Boost Filter Best Seller

function updateSwatch() {
    
    // init initImageSlider
    

      setTimeout(function() {
      var variantSelected = $('#boost-pfs-quickview-variants-selector').find("option:selected").data('variant-id')

      $('.boost-pfs-quickview-featured-image').each(function(){
        if($(this).attr('data-varId') != variantSelected){
          $(this).hide()
          $(this).removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).show();
        }
      });}, 200);
      
    
  
  setTimeout(function(){

    var variantId = $('#boost-pfs-quickview-variants-selector').find("option:selected").data('variant-id')
    var variantUrl = $('#boost-pfs-quickview-variants-selector').find("option:selected").data('variant-url')
    $('.quick_view-link a').attr('href', variantUrl  + '?variant=' + variantId);

  }, 100)

  setTimeout(function() {

    $.each($('.meta_description'), function(){
      if($(this).data('id') === $('#boost-pfs-quickview-variants-selector').find("option:selected").data('variant-id')){
        $(this).addClass('ProductMeta__VariantDescription--active')
      } else {
        $(this).removeClass('ProductMeta__VariantDescription--active')
      }
    });
  }, 100);

}

function addActive(){

    $('.boost-pfs-quickview-featured-image').each(function(){

        if($(this).attr('data-varid') == $('#boost-pfs-quickview-variants-selector').find("option:selected").data('variant-id'))
        {
          $(this).addClass('active');
          $(this).show();
        }
      
      });
  
}

function quickviewAdd(form) {
  var variantId = $('#boost-pfs-quickview-variants-selector').val();
  var quantity = $('#boost-pfs-quickview-cart-quantity').val();
  $.post('/cart/add.js', {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    }, function(data) {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: quantity
        }
      }));
      $('.boost-pfs-modal-backdrop').fadeOut(function() {
        $('.boost-pfs-quickview-close').click();
      });
    }, "json");
}


        


// Hide add-to-cart gift card
// jQuery(function() {
//   $(document).ready(function() {
//     if (window.location.href.indexOf("rise-ai-giftcard") > -1) {
//       $('.ProductForm__AddToCart:contains("Add to bag")').hide();
//       $('.SizeSwatchList li').on("click", function(){
//         setTimeout(function(){
//         $('.ProductForm__AddToCart:contains("Add to bag")').hide();
//         }, 100);
//       })

//     }
//   });
// });

// document.addEventListener("limoniapps:discountninja:cart:updated", function (event) { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})) });

// Replace the locations with the actual latitude and longitude of your desired locations
 /*       var locations = [
            { lat: 32.9620841, lng: -117.1924174, name: 'Carmel Valley, SD', address: '5980 Village Way Suite B104', city: 'San Diego', state: 'CA', zip: '92130'},
            { lat: 34.0369585, lng: -118.4459274, name: 'West LA', address: '5980 Village Way Suite B10', city: 'Los Angeles', state: 'CA', zip: '90064' },
            { lat: 33.0359436, lng: -117.2876837, name: 'Encinitas', address: '485 Santa Fe Dr', city: 'Encinitas', state: 'CA', zip: '92024' },
            // Add more locations as needed
        ];

        function initMap() {
            var mapOptions = {
                center: { lat: 37.0902, lng: -95.7129 }, // Choose the center of the map
                zoom: 4 // Choose the initial zoom level,

            };
            var mapContainers = document.getElementsByClassName('google-map');
            if (mapContainers.length > 0) {

            // Loop through all matching elements and initialize a map on each one
            for (var i = 0; i < mapContainers.length; i++) {
              var map = new google.maps.Map(mapContainers[i], mapOptions);
              var bounds = new google.maps.LatLngBounds();

            // Create markers for each location
            locations.forEach(function (location) {
                var marker = new google.maps.Marker({
                    position: { lat: location.lat, lng: location.lng },
                    map: map,
                    title: location.name
                });

                bounds.extend(marker.getPosition());

                 var contentString = `
                    <div class="marker-info">
                        <h4>${location.name}</h4>
                        <p>${location.address}</p>
                        <p>${location.city}, ${location.state}</p>
                    </div>
                `;

                // Add info window for each marker
                var infoWindow = new google.maps.InfoWindow({
                     content: contentString
                });

                marker.addListener('click', function () {
                    infoWindow.open(map, marker);
                });

            });
            // Automatically fit the map to all the markers
            map.fitBounds(bounds);
        }
      }

    }*/

/*jQuery(document).ready(function ($) {
  var charityChoice = (function () {
    $('body').on('change', 'input[name="charity-choice"]', function (e) {
      console.log("changed");
      var selectedValue = $('input[name="charity-choice"]:checked').val();
         console.log("Selected: " + selectedValue);
      $(".Product__InfoWrapper .charity-input").val(selectedValue);
    });

  }());
});
*/
$(document).on('click',".boost-pfs-quickview-qty-cartbtn .QuantitySelector__Button[data-action=increase-quantity]",function(){
    var newQty = +($("#boost-pfs-quickview-cart-quantity").val()) + 1;
    $("#boost-pfs-quickview-cart-quantity").val(newQty);
});
$(document).on('click',".boost-pfs-quickview-qty-cartbtn .QuantitySelector__Button[data-action=decrease-quantity]",function(){
    var newQty = +($("#boost-pfs-quickview-cart-quantity").val()) - 1;
    if(newQty < 1)newQty = 1;
    $("#boost-pfs-quickview-cart-quantity").val(newQty);
});


// Elimina la clase 'yotpo-device-mobile' de los elementos al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  var yotpoElement = document.querySelector('.yotpo-device-mobile');
  if (yotpoElement) {
    yotpoElement.classList.remove('yotpo-device-mobile');
  }
});

console.log('custom.js loaded');